import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnDynamicForm as CnDynamicFormView } from './view';
CnDynamicFormView.displayName = 'CnDynamicForm';
export var CnDynamicForm = withI18n(CnDynamicFormView, {
    locale: locale,
});
